// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'
import { sortBy } from 'lodash'

import { fullSystemStateSelector } from './fullFileFirstOrder'
import { initialSystemState } from '../store/initialSystemState'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').CustomTemplate} CustomTemplate
 * @typedef {import('../index').Templates} Templates
 * @typedef {import('../index').BuiltInTemplateState} BuiltInTemplateState
 * @typedef {import('../index').BuiltInTemplate} BuiltInTemplate
 */

/**
 * @type {function(PlottrState): Templates}
 */
const allTemplatesSelector = createSelector(fullSystemStateSelector, ({ templates }) => {
  return templates ?? initialSystemState.templates
})

/**
 * @type {function(PlottrState): BuiltInTemplateState}
 */
const unsortedStarterTemplatesSelector = createSelector(
  allTemplatesSelector,
  ({ templates }) => templates ?? initialSystemState.templates.templates
)
/**
 * @type {function(PlottrState): Array<BuiltInTemplate>}
 */
export const templatesSelector = createSelector(unsortedStarterTemplatesSelector, (templates) =>
  sortBy(Object.values(templates), 'name')
)
/**
 * @type {function(PlottrState): Array<CustomTemplate>}
 */
export const allCustomTemplatesSelector = createSelector(
  allTemplatesSelector,
  ({ customTemplates }) => customTemplates
)
/**
 * @type {function(PlottrState): Array<CustomTemplate>}
 */
export const fileSystemCustomTemplatesSelector = createSelector(
  allCustomTemplatesSelector,
  (customTemplates) => {
    return customTemplates.filter(({ isCloudTemplate }) => !isCloudTemplate)
  }
)
/**
 * @param {PlottrState} _state
 * @param {String} type
 * @return {String}
 */
const templateTypeSelector = (_state, type) => type
/**
 * @param {PlottrState} _state
 * @param {any} _
 * @param {String} searchTerm
 * @return {String}
 */
const templateSearchTermSelector = (_state, _, searchTerm) => searchTerm
/**
 * @type {function(PlottrState, String, String): any}
 */
export const filteredSortedStarterTemplatesSelector = createSelector(
  templatesSelector,
  templateTypeSelector,
  templateSearchTermSelector,
  (templates, type, searchTerm) => {
    return sortBy(
      templates.filter((t) => {
        if (searchTerm && searchTerm.length > 1) {
          return t.name.toLowerCase().includes(searchTerm) && t.type == type
        } else if (type) {
          return t.type == type
        } else {
          return true
        }
      }),
      'name'
    )
  }
)
